import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Request, Headers, ResponseContentType, ResponseOptions } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/Observable/throw';
import 'rxjs/add/operator/toPromise';
import { global } from '../../models/global';
import { JobItemList } from 'src/app/Models/Admin/jobitemspecification';

@Injectable({
  providedIn : 'root'
})
export class JobSpecificationService {

  ROOT_URL : string = "";
    constructor(private http : Http) {
        let g: global = new global();
        this.ROOT_URL = g.getApiUrl();
    }

    getJobList() : Observable<any> {
    let userID = localStorage.getItem('mcmt_userId');
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
    let requestoptions : RequestOptions = new RequestOptions({
        method : 'GET',
        url : this.ROOT_URL + "/api/JobSpecification/GetJobSpecification?userID="+userID,
        headers : headers
    })
    
    return this.http.request(new Request(requestoptions))
        .map((res : Response) => {
            return res.json();
        });

  }

  updateJobConfiguration(jobList:JobItemList[]) : Observable<any> {
    let _body = {
        "UserID" : localStorage.getItem('mcmt_userId'),
        "Data" : jobList
      }
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
    let requestoptions : RequestOptions = new RequestOptions({
        method : 'POST',
        url : this.ROOT_URL + "/api/JobSpecification/UpdateJobSpecification",
        headers : headers,
        body : _body
    })
    
    return this.http.request(new Request(requestoptions))
        .map((res : Response) => {
            return res.json();
        });

  }
}
